import { render, staticRenderFns } from "./HistoryMenu.vue?vue&type=template&id=6c260cc6&"
import script from "./HistoryMenu.vue?vue&type=script&lang=js&"
export * from "./HistoryMenu.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoryMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/HistoryMenu.vue
// module id = 2315
// module chunks = 1